<div class="container">
  <div #loyaltyImage class="loyalty-image">
    <img loading="lazy" [src]="loyalty.airline | airlineImage" (error)="errorHandler()">
  </div>
  <i aria-hidden="true" #planeIcon class="icon-plane"></i>
  <div class="loyalty-info-cont" (click)="selectLoyalty.emit(loyalty)">
    <span class="name">{{loyalty.airline | frequentFlyerName | async}}</span>
    <span class="dni">{{loyalty.number}}</span>
  </div>
  <div class="options" (click)="toggleOptions()">
    <span class="separator">●</span>
    <span class="separator">●</span>
    <span class="separator">●</span>
  </div>
</div>

<div *ngIf="showOptions" (click)="toggleOptions()" class="overlay-container"></div>

<div *ngIf="showOptions" class="transparent-container" (click)="toggleOptions()">
  <section class="opt-cont" [class.is-last]="isLast" [class.only-one]="onlyOne">
    <div class="options-container">
      <span class="edit" (click)="edit.emit(loyalty)">
        <i aria-hidden="true" class="icon-edit"></i>
        <span>{{'BUTTONS.EDIT' | transloco}}</span>
      </span>
      <span (click)="deleteLoyalty()">
        <i aria-hidden="true" class="icon-cancel"></i>
        <span>{{ 'BOOKING_MODULE.BILLING.DELETE' | transloco }}</span>
      </span>
    </div>
  </section>
</div>